import { Component, Input, OnInit, TemplateRef } from '@angular/core';
/**
 * The headerScreen component is responsible for rendering the header of the screen which contains two parts : Title and actions
 * There are four inputs passed to the Headerscreen component
 *
 * This class should not be modified.
 */
@Component({
  selector: 'app-header-screen',
  templateUrl: './header-screen.component.html'
})
export class HeaderScreenComponent implements OnInit {
  /**
   * Element for the actions region
   */
  @Input() actionsTemplate: TemplateRef<any>;
  /**
   * Element for the header title
   */
  @Input() headerTitle: TemplateRef<any>;

  isNewReport = false;

  ngOnInit() {
   if(window.location.pathname.includes("/new-reports-type")){
	    this.isNewReport = true
    }
  }
}
